import { createAsyncThunk } from "@reduxjs/toolkit";
import {  getUserMaliciousReports } from "store/services/dataManagement/maliciousWords";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetMaliciousReports = createAsyncThunk(
  "maliciousReports/get",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getUserMaliciousReports(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
